export const SHOPY_URL = 'https://lapinochachocolates.shopy.com.ar/';
